import {
  Locale,
  LocaleSchema,
  locales,
  type LocaleT,
  validateLocale,
} from '@vs-shop/schemas/tenant/locale';

import { getDefaultChannel } from './channel';
import { getChannelProfile } from './channelProfile';

// Locale vocabulary moved to `@vs-shop/schemas/tenant/locale` (Stage 2 MR-B,
// ENGINE_MOVE.md §3). This module keeps the env-coupled selection reader and
// re-exports the vocabulary for existing app importers. Which locale a channel
// uses is a tenant fact and lives in `channelProfile`.
export { Locale, LocaleSchema, locales, type LocaleT, validateLocale };

export const getDefaultLocale = (): LocaleT => getChannelProfile(getDefaultChannel()).locale;
